import { Button } from "flowbite-react";
import ArrowButton from "./ArrowButton";

const ButtonGsfurn = ({ children, isLoading, fullWidth, color, needsArrow, ...props }) => {
  return (
    <Button {...props} isProcessing={isLoading} color={color}>
      <div
        className={`
        group/arrow 
        ${fullWidth ? "flex w-full justify-between items-center" : "flex items-center justify-center w-full"}
      `}
      >
        {children}
        {needsArrow && <ArrowButton />}
      </div>
    </Button>
  );
};

export default ButtonGsfurn;